import { isPlatformBrowser } from '@angular/common';
import { ReTree } from './retree';
import { DeviceConstants } from './device-detector.constants';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceDetectorService {
  userAgent: string;
  reTree: ReTree;
  iPad = 'iPad';

  platformId = inject(PLATFORM_ID);

  constructor() {
    this.userAgent = '';
    this.reTree = new ReTree();
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined') {
      this.userAgent = window.navigator.userAgent;
    }
  }

  isMobile(userAgent = this.userAgent) {
    if (this.isTablet(userAgent)) {
      return false;
    }
    const match = Object.keys(DeviceConstants.MOBILES_RE).find((mobile) => {
      return this.reTree.test(userAgent, DeviceConstants.MOBILES_RE[mobile]);
    });
    return !!match;
  }

  isTablet(userAgent = this.userAgent) {
    if (
      isPlatformBrowser(this.platformId) &&
      (!!this.reTree.test(this.userAgent, DeviceConstants.TABLETS_RE[this.iPad]) ||
        (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    ) {
      return true;
    }
    const match = Object.keys(DeviceConstants.TABLETS_RE).find((mobile) => {
      return !!this.reTree.test(userAgent, DeviceConstants.TABLETS_RE[mobile]);
    });
    return !!match;
  }
}
